import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDocker,
  faGolang,
  faHtml5,
  faJava,
  faJenkins,
  faJs,
  faLinux,
  faNodeJs,
  faPython,
  faReact,
  faUnity,
} from "@fortawesome/free-brands-svg-icons";
import { DiGoogleCloudPlatform, DiMysql } from "react-icons/di";
import { VscAzure, VscMcp } from "react-icons/vsc";
import {
  SiChef,
  SiApachesolr,
  SiKubernetes,
  SiPrometheus,
  SiGrafana,
  SiAnsible,
  SiNginx,
  SiApachejmeter,
  SiFluentd,
  SiOpsgenie,
  SiApachespark,
  SiElasticsearch,
  SiPytorch,
  SiSupabase,
  SiFlask,
  SiRancher,
  SiFirebase,
  SiRundeck,
  SiLangchain,
  SiStreamlit,
  SiAlgolia,
  SiGithubactions,
  SiSpringboot,
  SiSplunk,
  SiOllama,
} from "react-icons/si";
import { GrHadoop } from "react-icons/gr";
import { CgCPlusPlus } from "react-icons/cg";
import { SlideInLeft, TypingText } from "./AnimationTrigger";
import { TbBrandCSharp } from "react-icons/tb";

const maxYear = 9;

const skills = {
  work: {
    languageFramework: {
      "name": "Language/Framework",
      "skills": [
        { name: "Python", proficiency: 9, icon: faPython, icontype: "fontawsome" },
        { name: "Java", proficiency: 2, icon: faJava, icontype: "fontawsome" },
        { name: "SpringBoot", proficiency: 2, icon: <SiSpringboot /> },
        { name: "Golang", proficiency: 7, icon: faGolang, icontype: "fontawsome" },
        { name: "C++", proficiency: 2, icon: <CgCPlusPlus /> },
      ]
    },
    infra: {
      "name": "Infra",
      "skills": [
        { name: "Docker", proficiency: 8, icon: faDocker, icontype: "fontawsome" },
        { name: "Kubernetes", proficiency: 6, icon: <SiKubernetes /> },
        { name: "Linux", proficiency: 7, icon: faLinux, icontype: "fontawsome" },
        { name: "GCP", proficiency: 4, icon: <DiGoogleCloudPlatform /> },
        { name: "Dify", proficiency: 2, icon: <span>D</span> },
      ]
    },
    dbMiddleware: {
      "name": "DB/Middleware",
      "skills": [
        { name: "Solr", proficiency: 7, icon: <SiApachesolr /> },
        { name: "MySQL", proficiency: 4, icon: <DiMysql />, size: "lg" },
        { name: "Hadoop/Hue", proficiency: 6, icon: <GrHadoop /> },
        { name: "Nginx", proficiency: 5, icon: <SiNginx /> },
        { name: "Spark", proficiency: 5, icon: <SiApachespark /> },
        { name: "Firebase", proficiency: 1, icon: <SiFirebase /> },
        { name: "Rancher", proficiency: 5, icon: <SiRancher /> },
      ]
    },
    monitoring: {
      "name": "Monitoring",
      "skills": [
        { name: "Prometheus", proficiency: 7, icon: <SiPrometheus /> },
        { name: "Grafana", proficiency: 7, icon: <SiGrafana /> },
        { name: "Fluentd", proficiency: 5, icon: <SiFluentd /> },
        { name: "Splunk", proficiency: 2, icon: <SiSplunk /> },
      ]
    },
    devOpsTesting: {
      "name": "DevOps/Testing",
      "skills": [
        { name: "Jenkins", proficiency: 6, icon: faJenkins, icontype: "fontawsome" },
        { name: "Chef", proficiency: 5, icon: <SiChef /> },
        { name: "Ansible", proficiency: 1, icon: <SiAnsible /> },
        { name: "JMeter", proficiency: 5, icon: <SiApachejmeter /> },
        { name: "Opsgenie", proficiency: 1, icon: <SiOpsgenie /> },
        { name: "Rundeck", proficiency: 5, icon: <SiRundeck /> },
      ],
    }
  },
  private: {
    languageFramework: {
      "name": "Language/Framework",
      "skills": [
        { name: "React", proficiency: 6, icon: faReact, icontype: "fontawsome" },
        { name: "Node.js", proficiency: 6, icon: faNodeJs, icontype: "fontawsome" },
        { name: "Javascript", proficiency: 6, icon: faJs, icontype: "fontawsome" },
        { name: "HTML/CSS/SASS", proficiency: 6, icon: faHtml5, icontype: "fontawsome" },
        { name: "Unity", proficiency: 2, icon: faUnity, icontype: "fontawsome" },
        { name: "C#", proficiency: 2, icon: <TbBrandCSharp /> },
        { name: "Flask", proficiency: 3, icon: <SiFlask /> },
        { name: "Streamlit", proficiency: 4, icon: <SiStreamlit /> },
        { name: "Langchain", proficiency: 2, icon: <SiLangchain /> },
        { name: "PyTorch", proficiency: 1, icon: <SiPytorch /> },
        { name: "Ollama", proficiency: 2, icon: <SiOllama /> },
        { name: "MCP Server", proficiency: 1, icon: <VscMcp /> },
      ]
    },
    infra: {
      "name": "Infra",
      "skills": [
        { name: "Azure", proficiency: 2, icon: <VscAzure /> }
      ]
    },
    dbMiddleware: {
      "name": "DB/Middleware",
      "skills": [
        { name: "Elasticsearch", proficiency: 3, icon: <SiElasticsearch /> },
        { name: "Supabase", proficiency: 3, icon: <SiSupabase /> },
        { name: "Algolia", proficiency: 1, icon: <SiAlgolia /> },
        { name: "Vespa", proficiency: 1, icon: <span>V</span> },
      ]
    },
    monitoring: {
      "name": "Monitoring",
      "skills": []
    },
    devOpsTesting: {
      "name": "DevOps/Testing",
      "skills": [
        { name: "GitHub Actions", proficiency: 3, icon: <SiGithubactions /> }
      ]
    },
  },
};

function SkillIcon({ skill }) {
  if (skill.icontype === "fontawsome") {
    return <FontAwesomeIcon icon={skill.icon} />;
  } else {
    return <>{skill.icon}</>;
  }
}

function SkillCard({ skill }) {
  const iconSize = skill.size === "lg" ? "skill-icon-lg" : "skill-icon";
  const textSize = skill.size === "lg" ? "skill-text-lg" : "skill-text";
  return (
    <div className="skill-card-main">
      <div className={iconSize}>
        <SkillIcon skill={skill} />
      </div>
      <div className={textSize}>{skill.name}</div>
      <div className="skill-progress-bar">
        <span style={{ width: `${(skill.proficiency / maxYear) * 100}%` }} />
        <p>{skill.proficiency} years</p>
      </div>
    </div>
  );
}

function CategorySection({ skills }) {
  if (skills.skills.length === 0) return null;

  return (
    <>
      <div className="division-title">
        <h4>{skills.name}</h4>
      </div>
      <div className="skill-cards">
        {skills.skills.map((skill) => (
          <SkillCard skill={skill} key={skill.name} />
        ))}
      </div>
    </>
  );
}

const SkillSection = ({ sectionTitle, skillCategories }) => (
  <>
    <div className="subtitle">
      <h3>{sectionTitle}</h3>
    </div>
    {Object.keys(skillCategories).map((category) => (
      <CategorySection skills={skillCategories[category]} key={category} />
    ))}
  </>
);

const Skill = ({ portfolioMode }) => {
  if (portfolioMode === "illustrator") {
    // For illustrator mode, skills/about are shown in the profile card
    // This component returns null to hide the section entirely
    return null;
  }

  return (
    <>
      <div className="title">
        <TypingText text="My Skills" wrapper="h2" />
      </div>
      <SlideInLeft component={<SkillSection sectionTitle="Work" skillCategories={skills.work} />} />
      <SlideInLeft component={<SkillSection sectionTitle="Private" skillCategories={skills.private} />} />
    </>
  );
};

export default Skill;
